import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"min-width":"35px"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"70%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"30%"} })
], -1)
const _hoisted_3 = { class: "border-b-2 border-gray-200 text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1)
const _hoisted_5 = {
  scope: "col",
  class: "py-1.5 font-medium"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "py-1.5 font-medium"
}, "Revalidate in", -1)
const _hoisted_7 = { class: "group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  class: "inline",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = ["src", "alt", "title"]
const _hoisted_13 = {
  key: 0,
  class: "hidden"
}
const _hoisted_14 = { colspan: "3" }
const _hoisted_15 = { class: "bg-neutral-50 pb-4 rounded-sm overflow-hidden" }
const _hoisted_16 = { class: "block m-6 ml-8 mb-4 text-lg font-medium" }
const _hoisted_17 = { class: "w-full mx-6 border-separate border-spacing-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "text-left font-medium"
}, "Location", -1)
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "text-left font-medium"
}, "AS", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "text-left font-medium whitespace-nowrap"
}, "AS name", -1)
const _hoisted_22 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import { A, AAAA, QueryResult } from '@/model/Api';


export default /*#__PURE__*/_defineComponent({
  __name: 'IpDnsRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  columnTitle: {
    type: String,
    required: true,
  },
  recordType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => props.records.response.answer.filter((item) => ['A', 'AAAA'].includes(item.record.recordType)));

function getIp(record: A | AAAA): string {
  if ('ipv4' in record) return record.ipv4;
  return record.ipv6.slice(1, -1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(showRawOutput))
      ? (_openBlock(), _createBlock(RawRecords, {
          key: 0,
          records: __props.records
        }, null, 8, ["records"]))
      : (_unref(processedRecords).length !== 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("th", _hoisted_5, _toDisplayString(__props.columnTitle), 1),
                _hoisted_6
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords), (record, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("tr", _hoisted_7, [
                    (record.ipInfo)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: "text-center",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(e => { e.target.closest('tr').nextSibling.classList.toggle('hidden'); e.target.closest('tr').querySelector('svg').classList.toggle('rotate-90') }, ["stop"]))
                        }, _hoisted_9))
                      : (_openBlock(), _createElementBlock("td", _hoisted_10)),
                    _createElementVNode("td", _hoisted_11, [
                      (record.ipInfo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "inline w-4 h-4 mb-0.5 mr-1.5",
                            src: `https://icons.duckduckgo.com/ip3/${record.ipInfo.asdomain}.ico`,
                            alt: `Hosted by ${record.ipInfo.asname}`,
                            title: `Hosted by ${record.ipInfo.asname}`
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(getIp(record.record)), 1),
                      _createVNode(CnameChainBadge, {
                        chain: record.cnameChain
                      }, null, 8, ["chain"]),
                      _createVNode(Copy, {
                        content: getIp(record.record),
                        class: "inline-block -mt-2 invisible group-hover:visible"
                      }, null, 8, ["content"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(Duration, {
                        seconds: record.record.ttl
                      }, null, 8, ["seconds"])
                    ])
                  ]),
                  (record.ipInfo)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", {
                              class: "w-full h-32 bg-center",
                              style: _normalizeStyle({ backgroundImage: `url(https://stadiamaps.com/static/outdoors?api_key=23fe682b-ac7c-4f2b-83db-39dcf2a8b9ac&center=${record.ipInfo.lat + 2},${record.ipInfo.lon}&zoom=2&markers=${record.ipInfo.lat},${record.ipInfo.lon}&size=1038x128)` })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(record.ipInfo.org), 1),
                            _createElementVNode("table", _hoisted_17, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_18,
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      href: `https://www.google.com/maps/search/${record.ipInfo.city}, ${record.ipInfo.regionName}, ${record.ipInfo.country}`,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      class: "text-blue-600 hover:text-blue-800 hover:underline"
                                    }, _toDisplayString(record.ipInfo.city) + ", " + _toDisplayString(record.ipInfo.regionName) + ", " + _toDisplayString(record.ipInfo.country), 9, _hoisted_19)
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_20,
                                  _createElementVNode("td", null, _toDisplayString(record.ipInfo.as), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_21,
                                  _createElementVNode("td", null, _toDisplayString(record.ipInfo.asname), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, "No " + _toDisplayString(__props.recordType) + " records found.", 1))
  ]))
}
}

})